import { Model } from '@/models/Model';
export class Project extends Model {
    constructor() {
        super(...arguments);
        this.$name = 'Project';
        this.$endpoint = '/projects';
        this.$fillable = ['name', 'description', 'steps', 'notes', 'files', 'subjects'];
    }
    detachSubjectsFromProject(projectId, subjects) {
        const url = `projects/${projectId}/detach-subjects`;
        const payload = { subjects };
        return this.request('put', url, payload);
    }
    duplicate() {
        const url = `projects/${this.id}/duplicate`;
        return this.request('post', url);
    }
    // v3/projects/{id}/subjects
    // public fetchProjectSubjects(projectId: string) {
    //   const url = `projects/${projectId}/subjects`;
    //   return this.request('get', url);
    // }
    fetchProjectSubjects() {
        const url = `projects/${this.id}/subjects`;
        return this.request('get', url);
    }
}
export var ProjectIncludes;
(function (ProjectIncludes) {
    ProjectIncludes["CHAT"] = "chat";
    ProjectIncludes["SUBJECTS"] = "subjects";
    ProjectIncludes["META"] = "meta";
    ProjectIncludes["LEVEL"] = "level";
    ProjectIncludes["AUDIT"] = "audit";
    ProjectIncludes["USERS"] = "users";
    ProjectIncludes["ROLES"] = "roles";
    ProjectIncludes["PARENT"] = "parent";
    ProjectIncludes["NOTES"] = "notes";
    ProjectIncludes["CREATED_BY"] = "created_by";
    ProjectIncludes["PROJECT_CATEGORY"] = "project_category";
})(ProjectIncludes || (ProjectIncludes = {}));
